import {InjectionToken} from '@angular/core';
import {IColumnSettings} from 'app/main/shared/shared/table/components/custom-columns-settings/column-settings';

export interface ICustomColumnService{
    getCustomColumns():  Omit<IColumnSettings<unknown>, 'uuid'>[];
}

export const ICustomColumnServiceToken = new InjectionToken<ICustomColumnService>('ICustomColumnServiceToken');
